import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: '[app-weighting-edit-toggle]',
  templateUrl: './weighting-edit-toggle.component.html',
  styleUrls: ['./weighting-edit-toggle.component.scss']
})
export class WeightingEditToggleComponent implements OnInit {

  @Input() editMode: boolean;

  @Output() toggleEvent = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  toggle() {
    this.toggleEvent.emit(true);
  }

}
